import { Injectable } from '@angular/core';
import { BaseUrlConstantsService } from './services/base-url-constants.service';
@Injectable({
  providedIn: 'root'
})
export class HealthCheckService {
  async checkBackendAvailability(): Promise<boolean> {
    let apiUrl = BaseUrlConstantsService.BASE_HOME_TAB_SERVICE + 'health-check';
    try {
      const response = await Promise.race([
        fetch(apiUrl),
        this.createTimeoutPromise(10000000)
      ]) as Response;
      return response.ok;
    } catch (error) {
      return false;
    }
  }

  private createTimeoutPromise(ms: number): Promise<never> {
    return new Promise((_, reject) => {
      setTimeout(() => reject('Request timed out'), ms);
    });
  }
}